<template>
  <div class="invoiceExplain">
    <Header :headerTitle="$t('m.invoiceExplain.title')"></Header>
    <ol>
      <li>{{ $t("m.invoiceExplain.context1") }}</li>
      <li>{{ $t("m.invoiceExplain.context2") }}</li>
      <li>{{ $t("m.invoiceExplain.context3") }}</li>
    </ol>
  </div>
</template>
<script>
export default {
  name: "invoiceExplain",
  data() {
    return {};
  },
};
</script>
<style scoped>
.invoiceExplain ol {
  margin: 10px 10px 10px 15px;
  padding-left: 14px;
}
.invoiceExplain ol li {
  text-align: left;
  margin-bottom: 5px;
  font-size: 0.96rem;
}
</style>
